import { render } from "./SimpleInputForm.vue?vue&type=template&id=2d64858d"
import script from "./SimpleInputForm.vue?vue&type=script&lang=js"
export * from "./SimpleInputForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__